import { PageShell, GetStarted } from '../../components';
import { PageBody, PageHero, Section, CardGrid } from '../../components/page';

const useCases = [
  {
    title: 'For AI agent developers',
    body: 'Connect agents to APIs without scattering keys across every config file. One token replaces dozens of credentials, and each agent gets its own identity.',
    href: '/use-cases/developers',
  },
  {
    title: 'For API providers',
    body: 'Expose your API to the AI ecosystem. Statio hosts the MCP server and handles auth and plan-based rate limits.',
    href: '/use-cases/providers',
  },
  {
    title: 'For enterprise security',
    body: 'Grant access per tool, keep the record of every call, and revoke any agent without touching the others.',
    href: '/use-cases/enterprise',
  },
];

export default function UseCasesIndex() {
  return (
    <PageShell>
      <PageBody>
        <PageHero
          title="Who Statio is for"
          lede="Three jobs, one gateway: reaching APIs from an agent, publishing an API to agents, and being answerable for what those agents did."
          art="sunrise"
        />
        <Section id="use-cases">
          <CardGrid items={useCases.map((u) => ({ ...u, linkLabel: 'Read more' }))} />
        </Section>
      </PageBody>
      <GetStarted />
    </PageShell>
  );
}
